import { render } from "./AddSrxFirewall.vue?vue&type=template&id=57dc5622"
import script from "./AddSrxFirewall.vue?vue&type=script&lang=js"
export * from "./AddSrxFirewall.vue?vue&type=script&lang=js"

import exportComponent from "/root/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__